module.exports = __webpack_public_path__ + "static/img/案例2.eb67862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/案例2.png
// module id = +1ON
// module chunks = 0